<div class="atf-mobile-container">

    <img class="iamsadey" src="./assets/img/ich_bin_sadey.svg">

    <h1>Dein persönlicher<br> Venue-Buchunsassistent
    </h1>

    <app-change-text [text]="['Finde freie Venues für deine Tour', 'Füge deine Venues hinzu', 'Plane deine Tour']">
    </app-change-text>
</div>